//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IScope } from 'angular';
import React from 'react';
import { ActionButton } from 'unison';

import makeAngularReactControllerWithScope, {
  applyScope,
} from '@react-bridge/angular-react-widget-with-scope';

interface IOwnProps {
  isDisabled: boolean;
  onClick: () => void;
}
type Props = IOwnProps;

const BeautifyActionButton: React.FunctionComponent<Props> = ({
  isDisabled,
  onClick,
}) => {
  return (
    <ActionButton
      iconName='beautify'
      label='Beautify'
      onClick={onClick}
      isDisabled={isDisabled}
    />
  );
};

angular.module('curalate').component('beautifyActionButton', {
  bindings: {
    isDisabled: '<',
    onClick: '&',
  },
  controller: makeAngularReactControllerWithScope(
    (scope: { $ctrl: IOwnProps } & IScope) => {
      return (
        <div>
          <BeautifyActionButton
            isDisabled={scope.$ctrl.isDisabled}
            onClick={applyScope(scope, scope.$ctrl.onClick)}
          />
        </div>
      );
    },
  ),
});
